var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTelescope = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 48 48",
  fill: "transparent",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14 44L26 34L38 44M26 28V44M30 12L36 23M8.58793 29.3589L8.91993 29.9209C9.95993 31.6809 12.1679 32.4509 14.1299 31.7409L42.6139 21.4109C42.895 21.314 43.1516 21.1569 43.3657 20.9507C43.5799 20.7445 43.7466 20.4941 43.8542 20.217C43.9617 19.9398 44.0076 19.6425 43.9885 19.3458C43.9695 19.0491 43.886 18.7601 43.7439 18.4989L38.5039 9.08894C38.2235 8.60213 37.7656 8.24277 37.2261 8.08617C36.6866 7.92958 36.1074 7.98791 35.6099 8.24894L35.4979 8.31294L10.1099 23.5489C8.06993 24.7749 7.39593 27.3429 8.58993 29.3589H8.58793Z",
  stroke: "currentcolor",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTelescope);
export default ForwardRef;